module.exports = __webpack_public_path__ + "static/media/international.9d3b35c8.svg";